'use strict';

import AppDispatcher from '../AppDispatcher';
import ActionTypes from '../constants/ActionTypes';
import SectionStore from './SectionStore';
import { createListStore, createListActionHandler } from '../utils/PaginatedStoreUtils';

const ZineSectionsStore = createListStore({
  getSections() {
    return this.getIds().map(SectionStore.get);
  }
});

const handleListAction = createListActionHandler({
  request: ActionTypes.REQUEST_ZINE_SECTIONS,
  error: ActionTypes.REQUEST_ZINE_SECTIONS_ERROR,
  success: ActionTypes.REQUEST_ZINE_SECTIONS_SUCCESS,
  preload: ActionTypes.PRELOAD_ZINE_SECTIONS
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([SectionStore.dispatchToken]);
  handleListAction(payload.action, ZineSectionsStore.getList(), ZineSectionsStore.emitChange);
});

export default ZineSectionsStore;


/** WEBPACK FOOTER **
 ** ./stores/ZineSectionsStore.js
 **/